// extracted by mini-css-extract-plugin
export default {"paginationControl":"SSMnkvg5amqA3Yhb3QAU","paginationButton":"X75jCGUhY3yZuzXQ835M","entries":"hGniTQRRIKlDXsdCVzNO"};